import Bonus from './Bonus';

export default Bonus;
